import React from 'react';

interface Props {
  className: string;
}

export const Skeleton: React.FC<Props> = ({ className }) => (
  <span
    aria-hidden
    className={`block animate-skeleton-shimmer rounded-xl bg-skeleton bg-[length:200%_100%] bg-[linear-gradient(90deg,var(--skeleton)_25%,var(--skeleton-highlight)_50%,var(--skeleton)_75%)] ${className}`}
  />
);
